<template>
    <div class="">
        <ReAiNavigate/>
		<div class="filter-tag-row">
			<ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/>
			<span class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">Запросов: {{this.masObjects_total}}</span>
		</div>	        
        <REAILogsLine v-for="line in ApiData" :key="line.id" :data="line"/>
		<Pagination :class="[{'': parseInt(masObjects_total) > 0}, {'d-none': parseInt(masObjects_total) < 1}]"
			:type="'info'" 
			:total="parseInt(masObjects_total)" 
			:perPage="parseInt(10)" 
			:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
			:pClick="pClick">
		</Pagination>        
    </div>
</template>
<script>
import Pagination from 'src/our_components/RePagination';
import ReFilterBtn from '../FilterPrinter/ReFilterBtn.vue';
import REAILogsLine from './REAILogsLine.vue';
import ReAiNavigate from './ReAiNavigate.vue';

export default{
    components:{
        REAILogsLine,
        ReFilterBtn,
        Pagination,
        ReAiNavigate,
    },
    data(){
        return {
            ApiData:[],
            bShowFilter: false, 
            masObjects_total: 0,
			count2page: 10,
			objGetParams: {},            
        }
    },
    methods:{
        async load(){
            try {
                this.ApiData=[];
                const flt = this.$GVO.GetAllGet();                
                const res = await this.$GVO.Api.AI.GET({flt});
                if (res && res.success) {
                    this.ApiData = res.data;
                    this.masObjects_total = res.total;
                    // console.log('API response:', res);
                } else {
                    // console.error('API call failed or returned no data:', res);
                    this.$GVO.showAlert('Ошибка', res.msg);
                }
            } catch (error) {
                // console.error('Unexpected error during API call:', error);
                this.$GVO.showAlert('Ошибка', error);
            }
        },
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			this.OnFilterApply();
		},
        OnFilterApply(data){
			//console.log('OnFilterApply_data',data);
			//console.log('OnFilterApply_get',this.$GVO.unlinkObject(this.objGetParams));

			this.bShowFilter=false;
			
			if(typeof data != 'undefined' && typeof this.objGetParams['p'] != 'undefined'){
				delete this.objGetParams['p'];
			}
			SGVO.prevRoute=null;		

			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
					if(this.objGetParams[key] == '{"inputText":"","selectedVal":""}') delete this.objGetParams[key];
				}
			}
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log('OnFilterApply',strItogGetParams,this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			// eventEmitter.$emit('OnFilterApply', this.objGetParams);
			this.load();
			
		},                
    },
    mounted(){
        this.load();
    }
}
</script>